/**
 * @description
 */

import React, { Component } from 'react';
import { $window } from '@umu/umu-dom';
import { PageDirection } from '@umu/umu-types';

import './basePageSliderPage.scss';

export interface IBaseProps<TD> {
    key: number;
    data: TD;
    pageOrder: number;
    currentIndex: number;
    direction?: PageDirection;
}

export interface IBaseState {
    isShow?: boolean;
}

export default class BasePageSliderPage<IP extends IBaseProps<D>, IS extends IBaseState, D = {}> extends Component<
    IP,
    IS
> {
    public static getDerivedStateFromProps(nextProps: IBaseProps<{}>, prevState: IBaseState) {
        // 之前 isShow === true 的，更新时不立即设置为 false ，而是通过延时函数设置
        return {
            isShow: prevState.isShow || nextProps.currentIndex === nextProps.pageOrder,
        };
    }

    private isShowTimer: number = 0;

    constructor(props: IP, state: IS) {
        super(props, state);

        this.state = {} as IS;
    }

    public hidePage = () => {
        this.isShowTimer = $window.setTimeout(() => {
            this.setState({
                isShow: false,
            });
        }, 400);
    };

    public componentWillUnmount() {
        clearTimeout(this.isShowTimer);
    }

    public renderPage(): JSX.Element | null {
        return null;
    }

    public componentDidUpdate(_prevProps: IP, prevState: IS) {
        if (!prevState.isShow) {
            return;
        }

        const { pageOrder, currentIndex, direction } = this.props;

        if (direction === PageDirection.Next && currentIndex - 1 === pageOrder) {
            // console.info('remove' + pageOrder);
            this.hidePage();
            return;
        } else if (direction === PageDirection.Prev && currentIndex + 1 === pageOrder) {
            // console.info('remove' + pageOrder);
            this.hidePage();
            return;
        }
    }

    public getPageWrapChildren() {
        return this.renderPage();
    }

    public renderPageWrap() {
        const { pageOrder, currentIndex, direction } = this.props;

        const ret = <div className="page-slider-page-wrap">{this.getPageWrapChildren()}</div>;

        if (!this.state.isShow) {
            return null;
        }

        // 限制最多展示2页，保证上下滑动时，切换的两页是有展示的
        if (currentIndex === pageOrder) {
            return ret;
        }

        if (direction === PageDirection.Next && currentIndex - 1 === pageOrder) {
            return ret;
        } else if (direction === PageDirection.Prev && currentIndex + 1 === pageOrder) {
            return ret;
        }

        return null;
    }

    public render() {
        return <div className="page-slider-page">{this.renderPageWrap()}</div>;
    }
}
